import 'angular-gettext';
import { calculateAverages, calculateTotals } from '../../../common/fp/objects';
import { sortBy } from 'lodash/fp';
import api, { ApiService } from '../../../common/api/api.service';
import help, { HelpService } from '../../../common/help/help.service';

export class AppointmentsController {
    accountList: any;
    averages: any;
    data: any;
    loading: boolean;
    period: 'w' | 'm';
    showHelpButton = true;
    constructor(
        private $log: ng.ILogService,
        private api: ApiService,
        private gettextCatalog: ng.gettext.gettextCatalog,
        private help: HelpService,
    ) {
        if (!this.help.variables().HS_COACHING_APPOINTMENTS_AND_RESULTS?.length) {
            this.showHelpButton = false;
        }
    }
    $onChanges() {
        this.data = {};
        if (this.accountList) {
            this.load();
        }
    }
    load(): ng.IPromise<void> {
        this.loading = true;
        return this.api
            .get('reports/appointment_results', {
                filter: {
                    account_list_id: this.accountList.id,
                    range: `4${this.period}`,
                },
            })
            .then((data) => {
                /* istanbul ignore next */
                this.$log.debug('reports/appointment_results', data);
                this.data = sortBy('start_date', data);
                this.calculateAverages();
                this.loading = false;
            });
    }
    private calculateAverages() {
        const totals = this.calculateTotals();
        this.averages = calculateAverages(4, totals);
    }
    private calculateTotals() {
        let totals = {
            appointments_scheduled: 0,
            individual_appointments: 0,
            monthly_decrease: 0,
            monthly_increase: 0,
            new_monthly_partners: 0,
            new_special_pledges: 0,
            special_gifts: 0,
        };
        return calculateTotals(totals, 4, this.data);
    }
    showHelp(): void {
        this.help.article(this.gettextCatalog.getString(this.help.variables().HS_COACHING_APPOINTMENTS_AND_RESULTS));
    }
}

const Appointments: ng.IComponentOptions = {
    template: require('./appointments.html'),
    controller: AppointmentsController,
    bindings: {
        accountList: '<',
        period: '<',
    },
};

export default angular
    .module('mpdx.coaches.show.appointments.component', ['gettext', api, help])
    .component('appointments', Appointments).name;
